import { Controller } from '@hotwired/stimulus';

export class VerifyAddressController extends Controller {
  static targets = [
    'verifiedAt',
    'isCommercial',
    'formSource',
    'form',
    'nameSource',
    'name',
    'attentionSource',
    'attention',
    'address1Source',
    'address1',
    'address2Source',
    'address2',
    'citySource',
    'city',
    'stateSource',
    'state',
    'zipcodeSource',
    'zipcode',
    'countrySource',
    'country',
  ];

  submit(event) {
    if (!this.hasFormTarget) return;
    if (!this.hasCountrySourceTarget) return;
    if (this.countrySourceTarget.value !== 'US') return;

    event.preventDefault();

    if (event.params.step === 'commit') {
      // IMPROVE: potentially handle updating address from suggested format
      // presented to user

      if (this.hasVerifiedAtTarget) {
        this.verifiedAtTarget.disabled = false;
      }

      if (this.hasIsCommercialTarget && event.params?.commercial) {
        this.isCommercialTarget.value = 'true';
        this.isCommercialTarget.disabled = false;
      }

      this.formSourceTarget.submit();

      return;
    }

    if (this.hasNameSourceTarget && this.hasNameTarget) {
      this.nameTarget.value = this.nameSourceTarget.value;
    }

    if (this.hasAttentionSourceTarget && this.hasAttentionTarget) {
      this.attentionTarget.value = this.attentionSourceTarget.value;
    }

    if (this.hasAddress1SourceTarget && this.hasAddress1Target) {
      this.address1Target.value = this.address1SourceTarget.value;
    }

    if (this.hasAddress2SourceTarget && this.hasAddress2Target) {
      this.address2Target.value = this.address2SourceTarget.value;
    }

    if (this.hasCitySourceTarget && this.hasCityTarget) {
      this.cityTarget.value = this.citySourceTarget.value;
    }

    if (this.hasStateSourceTarget && this.hasStateTarget) {
      this.stateTarget.value = this.stateSourceTarget.value;
    }

    if (this.hasZipcodeSourceTarget && this.hasZipcodeTarget) {
      this.zipcodeTarget.value = this.zipcodeSourceTarget.value;
    }

    if (this.hasCountrySourceTarget && this.hasCountryTarget) {
      this.countryTarget.value = this.countrySourceTarget.value;
    }

    this.formTarget.requestSubmit();
  }
}
